import { useEffect, useRef } from 'react';
import { ChatWidget, ChatWidgetHandle } from './components/ChatWidget';
import { useSocket } from './hooks/useSocket';
import { WidgetConfig } from './types';

interface EmbedAppProps {
  config: WidgetConfig;
}

export const EmbedApp = ({ config }: EmbedAppProps) => {
  const { state, messages, dynamicConfig, assigneeInfo, configLoaded, chatReady, sendMessage, sendMediaMessage, registerPush, connect, disconnect, endConversation } = useSocket(config);
  const widgetRef = useRef<ChatWidgetHandle>(null);

  // Expose API to window for external control
  useEffect(() => {
    window.TroiaWidget = {
      open: () => {
        widgetRef.current?.open();
      },
      close: () => {
        widgetRef.current?.close();
      },
      send: sendMessage
    };

    return () => {
      delete window.TroiaWidget;
    };
  }, [sendMessage]);

  return (
    <ChatWidget
      ref={widgetRef}
      config={config}
      state={state}
      messages={messages}
      dynamicConfig={dynamicConfig}
      assigneeInfo={assigneeInfo}
      configLoaded={configLoaded}
      chatReady={chatReady}
      hidden={config.hidden}
      onSendMessage={sendMessage}
      onSendMedia={sendMediaMessage}
      onRegisterPush={registerPush}
      onConnect={connect}
      onClose={disconnect}
      onEndConversation={endConversation}
    />
  );
};
